import { Scene } from "../../tools/Scene";
import { SceneManager } from "../../managers/SceneManager";
import { GameManager } from "../../managers/GameManager";
import { Button } from "../../ui/Button";
import { ScaleManager } from "../../managers/ScaleManager";
import { MuteButton } from "./MuteButton";
import { LocalizationManager } from "../../managers/LocalizationManager";
import { GameType, PracPlay } from "../../models/CBNGameModel";
import { LetteratiGameSceneModel } from "../../viewModels/LetteratiGameSceneModel";
import { LetteratiTitle } from "./LetteratiTitle";
import { LetteratiGameScene } from "./LetteratiGameScene";

export class TitleScene extends Scene{

    titleBg:Phaser.GameObjects.Image|null = null;

    title:LetteratiTitle|null = null;

    playButton:Button|null = null;
    practiceButton:Button|null = null;

    prescaleCreate(){
        let image:Phaser.GameObjects.Image;
        let sprite:Phaser.GameObjects.Sprite;
        let button:Button;
        let position;
        let group;

        position = this.scaleManager.getRelativePosition(.5,.5);
        image = this.add.image(position.x,position.y,'title_bg');
        this.titleBg = image;
        // this.titleBg.visible = false;

        this.title = new LetteratiTitle(this);
        
        if(this.gameManager.cbnGameConfig!.willPracticePlay == PracPlay.option){
            position = this.scaleManager.getRelativePosition(0.3,.9);
            this.playButton = new Button(this,'btn_play',position.x,position.y,{text:LocalizationManager.getText('PLAY'),style:LocalizationManager.getStyle('PLAY')});
            this.playButton.emitter.once('buttonup',this.startQuiz,this);
            this.playButton.buttonPressedSprite = 'btn_play_pressed'

            position = this.scaleManager.getRelativePosition(0.7,.9);
            this.practiceButton = new Button(this,'btn_play',position.x,position.y,{text:LocalizationManager.getText('PRACTICE'),style:LocalizationManager.getStyle('PRACTICE')});
            this.practiceButton.emitter.once('buttonup',this.startPracticeQuiz,this);
            this.practiceButton.buttonPressedSprite = 'btn_play_pressed'

        }else if(this.gameManager.cbnGameConfig!.willPracticePlay == PracPlay.play){
            position = this.scaleManager.getRelativePosition(0.5,.9);
            this.playButton = new Button(this,'btn_play',position.x,position.y,{text:LocalizationManager.getText('PLAY'),style:LocalizationManager.getStyle('PLAY')});
            this.playButton.emitter.once('buttonup',this.startQuiz,this);
            this.playButton.buttonPressedSprite = 'btn_play_pressed'
        }
        else if(this.gameManager.cbnGameConfig!.willPracticePlay == PracPlay.practice){
            position = this.scaleManager.getRelativePosition(0.5,.9);
            this.practiceButton = new Button(this,'btn_play',position.x,position.y,{text:LocalizationManager.getText('PRACTICE'),style:LocalizationManager.getStyle('PRACTICE')});
            this.practiceButton.emitter.once('buttonup',this.startPracticeQuiz,this);
            this.practiceButton.buttonPressedSprite = 'btn_play_pressed'
        }

        position = this.scaleManager.getRelativePosition(0,0);
        // position = new Phaser.Math.Vector2(position.x + 0,position.y + -15);
        // new MuteButton(this, position,new Phaser.Math.Vector2(0,0));

        if((<GameManager>GameManager.instance).cbnGameConfig!.gameType == GameType.single){
            this.sound.volume = 0;
        }else {
            position = new Phaser.Math.Vector2(position.x + 0,position.y + -15);
            new MuteButton(this, position,new Phaser.Math.Vector2(0,0));
        }
        
        //BGM
        let bgm = (<Array<any>>(<any>this.sound).sounds).find(sound => sound.key == 'bgm' );
        if(bgm==null){
            bgm = this.sound.add('bgm');
            bgm.play(undefined,{
                loop:true
            });
        }
        
        if(this.gameManager.cbnGameConfig!.gameType != GameType.full && this.gameManager.cbnGameConfig!.willDisplayTitle == false){
            if(this.gameManager.cbnGameConfig!.willPracticePlay != PracPlay.practice)
                this.startQuiz();
            else
                this.startPracticeQuiz();
        }

        //Add Scene event bindings
        this.events.on('resize',this.onSceneResize,this);
    }

    reorient(landscape:boolean){
        let position;
        if(this.title){
            this.title.reorient(landscape);
        }
        if(landscape){
            position = this.scaleManager.getRelativePosition(.5,.5);
            this.titleBg!.setPosition(position.x,position.y);
            this.titleBg!.setTexture('lan_gen_bg');
            
            if(this.gameManager.cbnGameConfig!.willPracticePlay == PracPlay.option){
                position = this.scaleManager.getRelativePosition(0.3,.9);
                Phaser.Actions.SetXY(this.playButton!.group.getChildren(),position.x,position.y);

                position = this.scaleManager.getRelativePosition(0.7,.9);
                Phaser.Actions.SetXY(this.practiceButton!.group.getChildren(),position.x,position.y);
            }else if(this.gameManager.cbnGameConfig!.willPracticePlay == PracPlay.play){
                position = this.scaleManager.getRelativePosition(0.5,.9);
                Phaser.Actions.SetXY(this.playButton!.group.getChildren(),position.x,position.y);
            }
            else if (this.gameManager.cbnGameConfig!.willPracticePlay == PracPlay.practice)
            {
                position = this.scaleManager.getRelativePosition(0.5,.9);
                Phaser.Actions.SetXY(this.practiceButton!.group.getChildren(),position.x,position.y);
            }
        }else{
            position = this.scaleManager.getRelativePosition(.5,.5);
            this.titleBg!.setPosition(position.x,position.y);
            this.titleBg!.setTexture('por_gen_bg');
            
            if(this.gameManager.cbnGameConfig!.willPracticePlay == PracPlay.option){
                position = this.scaleManager.getRelativePosition(0.5,.75);
                Phaser.Actions.SetXY(this.playButton!.group.getChildren(),position.x,position.y);

                position = this.scaleManager.getRelativePosition(0.5,.85);
                Phaser.Actions.SetXY(this.practiceButton!.group.getChildren(),position.x,position.y);
            }else if(this.gameManager.cbnGameConfig!.willPracticePlay == PracPlay.play){
                position = this.scaleManager.getRelativePosition(0.5,.8);
                Phaser.Actions.SetXY(this.playButton!.group.getChildren(),position.x,position.y);
            }else if(this.gameManager.cbnGameConfig!.willPracticePlay == PracPlay.practice){
                position = this.scaleManager.getRelativePosition(0.5,.8);
                Phaser.Actions.SetXY(this.practiceButton!.group.getChildren(),position.x,position.y);
            }   
        }

        this.rescaleBackground();
    }

    rescaleBackground():void {
        //rescale background
        let ratio = this.scaleManager.getRatio();

        if(this.titleBg!.width * this.titleBg!.scaleX != window.innerWidth || this.titleBg!.height * this.titleBg!.scaleY != window.innerHeight)
        {
            this.titleBg!.setScale(this.sys.canvas.width/this.titleBg!.width / ratio! , this.sys.canvas.height/this.titleBg!.height / ratio!);
        }
    }

    startQuiz(){
        let gameManager = (<GameManager>GameManager.instance);
        gameManager.pracPlayOption = PracPlay.play;
        let quizModel;
        if(gameManager.cbnGameConfig!.gameType == GameType.full){
            quizModel = gameManager.gameConfig!.createRandomQuiz(245);
        }else{
            quizModel = gameManager.gameConfig!.createRandomQuiz(1);
        }
        
        //console.log("GameType:"+this.gameManager.cbnGameConfig!.gameType);
        if(this.gameManager.cbnGameConfig!.gameType == GameType.daily){
            quizModel.currentScore = this.gameManager.cbnGameConfig!.previousScore;
            console.log("Daily Previous Score:"+quizModel.currentScore);
        }
        let gameScene = new LetteratiGameScene({key:'LetteratiGameScene'+Math.random()},new LetteratiGameSceneModel(quizModel));
        SceneManager.changeScene(this,gameScene);
    }

    onSceneResize(event:Phaser.Scene):void {
        this.rescaleBackground();
    }

    startPracticeQuiz(){
        let gameManager = (<GameManager>GameManager.instance);
        gameManager.pracPlayOption = PracPlay.practice;
        let quizModel;
        if(gameManager.cbnGameConfig!.gameType == GameType.full){
            quizModel = gameManager.gameConfig!.createRandomQuiz(245, true);
        }else{
            quizModel = gameManager.gameConfig!.createRandomQuiz(1, true);
        }
        let gameScene = new LetteratiGameScene({key:'LetteratiGameScene'+Math.random()},new LetteratiGameSceneModel(quizModel));
        SceneManager.changeScene(this,gameScene);
    }
}